import * as React from "react";
import { Router, Switch, Route, RouteComponentProps, Redirect } from "react-router";
import { Welcome } from "./welcome/Welcome";
import StepFlow from "./step-flow/StepFlow";
import GerencialQuotes from "./gerencial/quotes/GerencialQuotes";
import Login from "./login/Login";
import UserList from "./manager/users/UserList";
import User from "./manager/users/UserEdit";
import { AuthContext } from "src/components/context/AuthContext";
import { Logout } from "./logout/Logout";
import OfficerSecureRoute from "./SecureRoute";
import { MainLayout } from "../components/common/main-layout/MainLayout";
import PasswordRecover from "src/pages/password-recover/PasswordRecover";

import * as messages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import { useEffect, useMemo, useState } from "react";
import GerencialOperacoesList from "./gerencial/operacoes/trades/GerencialOperacoesList";
import MonitorPrecatoriosList from "./monitor/precatorios/MonitorPrecatoriosList";
import GerencialPrecatoriosList from "./gerencial/precatorios/MonitorPrecatoriosList";
import UploadDocs from "./monitor/upload/UploadDocsContainer";
import ManualTradeEditContainer from "./monitor/edit/manual-trade/ManualTradeEditContainer";
import NotFound from "src/pages/erros/NotFound/NotFound";
import ManualCalculation from "src/pages/ferramentas/manual-calculation/ManualCalculation";
import MonitorPrecatoriosCreateNewOrUpdate from "src/pages/monitor/precatorios/MonitorPrecatoriosCreateNewOrUpdate";

import "./index.scss";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import Archived from "./monitor/archived/Archived.page";
import TradeSpecialProjectPage from "./monitor/trade-special-project/TradeSpecialProject.page";
import PostPurchasePage from "./monitor/post-pruchase/PostPurchase.page";
import MyOperationsPage from './monitor/operacoes/trades/MyOperations.page';
import QuoteEditPage from "./monitor/my-quotes/QuoteEdit.page";
import TradesPendenciesPage from './monitor/operacoes/pendencia/TradesPendencies.page';
import FAQPage from "./help/faq/faq.page";
import MonitorPrecatoriosConsult from './monitor/precatorios/MonitorPrecatoriosConsult';
import AllQuotesTable from './monitor/my-quotes/AllQuotesTable';
import UserQuotesTable from './monitor/my-quotes/UserQuotesTable';
import DemandedExpensesPage from './expenses/DemandedExpenses/DemandedExpenses.page';
import { ScheduledExpensesPage } from './expenses/ScheduledExpenses/ScheduledExpenses.page';
import { PaidExpensesPage } from './expenses/PaidExpenses/PaidExpenses.page';
import { RejectedExpensesPage } from './expenses/RejectedExpenses/RejectedExpenses.page';
import { InReviewExpensesPage } from './expenses/InReview/InReviewExpenses/InReviewExpenses.page';
import RequestExpensePage from './expenses/RequestExpense/RequestExpense.page';
import SentPendency from "./monitor/operacoes/pendencia/SentPendency.page";
import RejectedPage from './monitor/rejected/Rejected.page';
import { AllPrePrecatoriosQuotesPage } from './monitor/my-quotes/AllPrePrecatoriosQuotesPage';

export function Officer(props: RouteComponentProps) {
  const { isOfficer, currentUser } = React.useContext(AuthContext);
  const [path, setPath] = useState("/");

  const RouteTree: string[] = currentUser
    ? currentUser.profiles !== undefined
      ? currentUser.profiles
        .map(e => e.rules.concat(currentUser.rules).map(x => x.resources.map(y => y.match)))
        .map(arr => arr.map(e => e.flat(1)))
        .flat(200) : [] : [];

  useEffect(() => {
    loadMessages(messages);
    locale("pt-br");
  }, []);

  useMemo(() => {
    if (props.location.pathname !== "/" && !props.location.pathname.includes("/login")) {
      setPath(props.location.pathname);
    }
  }, [props.location.pathname]);

  const isRedirectRoute = !['/login', '/password-recover'].some(route => props.location.pathname.includes(route))

  if (!currentUser && isRedirectRoute) {
    return <Redirect to="/login" />;
  }

  return (
    <Router history={props.history}>
      <React.Suspense fallback={<div />}>
        {(isOfficer() && (
          <MainLayout className="officer">
            {RouteTree.length > 0 && (
              <Switch>
                <OfficerSecureRoute exact path="/" component={(router: any) => <Welcome {...router} />} />
                {RouteTree.findIndex(e => e.includes("/officer/usuarios")) !== -1 && <OfficerSecureRoute exact path="/usuarios/:id" component={router => <User {...router} />} />}
                {RouteTree.findIndex(e => e.includes("/officer/usuarios")) !== -1 && <OfficerSecureRoute exact path="/usuarios" component={router => <UserList {...router} />} />}
                {RouteTree.findIndex(e => e.includes("/officer/nf-payment/request")) !== -1 && (
                  <OfficerSecureRoute exact path="/nf-payment/request" component={(router: any) => <RequestExpensePage {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/nf-payment/demmanded")) !== -1 && (
                  <OfficerSecureRoute exact path="/nf-payment/demmanded" component={(router: any) => <DemandedExpensesPage {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/nf-payment/scheduled")) !== -1 && (
                  <OfficerSecureRoute exact path="/nf-payment/scheduled" component={(router: any) => <ScheduledExpensesPage {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/nf-payment/paid")) !== -1 && (
                  <OfficerSecureRoute exact path="/nf-payment/paid" component={(router: any) => <PaidExpensesPage {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/nf-payment/in-review")) !== -1 && (
                  <OfficerSecureRoute exact path="/nf-payment/in-review" component={(router: any) => <InReviewExpensesPage {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/nf-payment/rejected")) !== -1 && (
                  <OfficerSecureRoute exact path="/nf-payment/rejected" component={(router: any) => <RejectedExpensesPage {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/monitor/operacoes")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/operacoes" component={(router: any) => <MyOperationsPage {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/monitor/operacoes-com-pendencias")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/operacoes-com-pendencias" component={(router: any) => <TradesPendenciesPage {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/monitor/pending-sent")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/pending-sent" component={(router: any) => <SentPendency {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/monitor/precatorios/list")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/precatorios/list" component={(router: any) => <MonitorPrecatoriosList {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/monitor/precatorios/list")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/precatorios/list/:precatorioId" component={(router: any) => <MonitorPrecatoriosCreateNewOrUpdate {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/monitor/precatorios/consult")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/precatorios/consult" component={(router: any) => <MonitorPrecatoriosConsult {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/monitor/precatorios/consult")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/precatorios/consult/:cpf" component={(router: any) => <MonitorPrecatoriosConsult {...router} />} />
                )}

                {RouteTree.findIndex(e => e.includes("/officer/monitor/cotacoes/user")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/cotacoes/user" component={(router: any) => <UserQuotesTable {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/monitor/cotacoes/all")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/cotacoes/all" component={(router: any) => <AllQuotesTable {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/monitor/cotacoes")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/cotacoes/:quoteId" component={(router: any) => <QuoteEditPage {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/monitor/pre-precatorio/all")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/pre-precatorio/all" component={(router: any) => <AllPrePrecatoriosQuotesPage {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/monitor/archived")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/archived" component={(router: any) => <Archived {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/monitor/rejected")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/rejected" component={(router: any) => <RejectedPage {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/gerencial/operacoes")) !== -1 && (
                  <OfficerSecureRoute exact path="/gerencial/operacoes" component={(router: any) => <GerencialOperacoesList {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/gerencial/precatorios")) !== -1 && (
                  <OfficerSecureRoute exact path="/gerencial/precatorios" component={(router: any) => <GerencialPrecatoriosList {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/gerencial/cotacoes")) !== -1 && (
                  <OfficerSecureRoute exact path="/gerencial/cotacoes" component={(router: any) => <GerencialQuotes {...router} />} />
                )}

                {RouteTree.findIndex(e => e.includes("/officer/monitor/notificar")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/manual-trade/edit/:id" component={(router: any) => <ManualTradeEditContainer {...router} />} />
                )}

                {RouteTree.findIndex(e => e.includes("/officer/workflow/approved-special-project")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/trade-special-project" component={(router: any) => <TradeSpecialProjectPage {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/workflow/approved-post-purchase")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/trade-post-purchase" component={(router: any) => <PostPurchasePage {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/monitor/upload")) !== -1 && (
                  <OfficerSecureRoute exact path="/monitor/upload" component={(router: any) => <UploadDocs {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/ferramentas/calculadora/manual")) !== -1 && (
                  <OfficerSecureRoute exact path="/ferramentas/calculadora/manual" component={(router: any) => <ManualCalculation {...router} />} />
                )}
                {RouteTree.findIndex(e => e.includes("/officer/help/faq")) !== -1 && (
                  <OfficerSecureRoute exact path="/help/faq" component={(router: any) => <FAQPage {...router} />} />
                )}
                <OfficerSecureRoute path="/venda/:id" component={router => <StepFlow {...router} />} />

                <Route path="/login" component={router => <Redirect to={path} />} />
                <Route path="/password-recover" component={router => <Redirect to={path} />} />
                <Route path="/logout" component={Logout} />
                <Route component={router => <NotFound {...router} />} />
              </Switch>
            )}
          </MainLayout>
        )) || (
            <Switch>
              <Route path="/password-recover" render={() => (isOfficer() ? <Redirect to={path} /> : <PasswordRecover />)} />
              <Route exact path="/login" component={router => (isOfficer() ? <Redirect to={path} /> : <Login />)} />
              <Route path="/" component={router => <Redirect to="/login" />} />
            </Switch>
          )}
      </React.Suspense>
    </Router>
  );
}

export { Officer as default };



// WEBPACK FOOTER //
// ./src/pages/Routers.tsx